import { Controller } from "@hotwired/stimulus";

// Generic controller to show/hide elements based on localStorage keys
export default class extends Controller {
  static values = {
    keys: Array,
  };

  connect() {
    if (this.shouldHide()) {
      this.hideElement();
    }
  }

  hide(event) {
    const key = event.params.key;
    if (key) {
      localStorage.setItem(key, "true");
      this.hideElement();
    }
  }

  mark(event) {
    const key = event.params.key;
    if (key) {
      localStorage.setItem(key, "true");
    }
  }

  shouldHide() {
    return this.keysValue.some((key) => localStorage.getItem(key) === "true");
  }

  hideElement() {
    this.element.style.display = "none";
  }
}
